import { render, staticRenderFns } from "./booking-shipping.vue?vue&type=template&id=2b0bf97a&"
import script from "./booking-shipping.vue?vue&type=script&lang=js&"
export * from "./booking-shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports